import { UserEmailNotification } from 'src/types'

export default function sanitizeToPost(
  values: UserEmailNotification
): UserEmailNotification {
  const sanitized = JSON.parse(JSON.stringify(values))
  delete sanitized.key
  delete sanitized.reason

  sanitized.user_email_notification_id =
    +sanitized.user_email_notification_id || null
  sanitized.reason_id = +sanitized.reason_id || null

  return sanitized
}
